import { Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'

export const TeamUpGuide = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 1')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t(
          'Click on the button below to choose your team members. Alternatively, you can go to the Team page and do this on your own',
        )}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 2')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('Choose which Miner Mole(s) you want to join your Expedition Team')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 3')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('If the above transaction is successful, you have fulfilled this quest!')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('One-time only task: This is a one-time quest')}
      </Text>
    </>
  )
}
